import { useTranslation } from 'react-i18next';
import type { PageSize } from '@platform/core/types';
import type { IPaginationProps } from './IPaginationProps';
import './toolbar/toolbar.css';

const SIZES: PageSize[] = [10, 15, 25, 50, 100];

/**
 * Пагінація (UIUX tables/pagination, прототип v4): ліворуч «1–15 з 397» моноширинним, праворуч «15 на сторінці», «« ‹ Сторінка 1 з 27 › »»
 * (кнопки 30px з підказками); над нею — лінія --line. Порожній список — лише «0 записів».
 */
export function Pagination({ page, pageSize, total, onPage, onPageSize }: IPaginationProps) {
  const { t } = useTranslation();
  const pages = Math.max(1, Math.ceil(total / pageSize));
  const from = total === 0 ? 0 : (page - 1) * pageSize + 1;
  const to = Math.min(total, page * pageSize);
  if (total === 0) return <div className="lv-pager"><span className="lv-pager__range">{t('modules.records', { count: 0 })}</span></div>;
  const nav = (label: string, text: string, target: number, disabled: boolean) => (
    <button type="button" className="lv-pager__btn" aria-label={label} title={label} disabled={disabled} onClick={() => onPage(target)}>{text}</button>
  );
  return (
    <div className="lv-pager">
      <span className="lv-pager__range">{t('listbar.range', { from, to, total })}</span>
      <div className="lv-pager__nav">
        <select className="lv-select" value={pageSize} aria-label={t('listbar.pageSize')} onChange={(e) => onPageSize(Number(e.target.value) as PageSize)}>
          {SIZES.map((s) => <option key={s} value={s}>{t('listbar.perPage', { count: s })}</option>)}
        </select>
        {nav(t('listbar.first'), '«', 1, page <= 1)}
        {nav(t('listbar.prev'), '‹', page - 1, page <= 1)}
        <span className="lv-pager__page">{t('listbar.pageOf', { page, pages })}</span>
        {nav(t('listbar.next'), '›', page + 1, page >= pages)}
        {nav(t('listbar.last'), '»', pages, page >= pages)}
      </div>
    </div>
  );
}
